import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

type ThisApi = ApiDefinition['/district-templates/{id}/document-configs']['POST'];
type Input = ThisApi['params'] & ThisApi['body'];
type Output = ThisApi['response'];

/** Creates a new document config for a district template. */
const createDistrictDocumentConfig = async ({ id, ...body }: Input): Promise<Output> => {
  const path = buildPath<ThisApi>('/district-templates/{id}/document-configs', { id });
  const response = await noodleApiClient.post(path, body);
  return response.data;
};

export default createDistrictDocumentConfig;
